module.exports = __webpack_public_path__ + "static/app-store-badge-new-bbeb699524c428d26ca4e2cd3929cd46.png";